import axios from 'axios';
import {toast} from 'react-toastify';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import { composePhone } from 'src/features/common/phone/phoneUtils'

export async function updateLead(leadUpdate){
    try{
        const messageSuccess = 'Guardaste los datos correctamente.'
        const body = {
          ...leadUpdate,
          phone: composePhone(leadUpdate.phoneCountryCode, leadUpdate.phone) || leadUpdate.phone,
        }
        const res = await axios.put(`${LEADS_ENDPOINT}/${leadUpdate.lead_id}`, body)
        toast.success(messageSuccess)
        return res
    }catch(error){
        toast.error(error.message)
        console.log(error)
    }
}
